import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';


@Component({
  selector: 'app-client-process',
  templateUrl: './client-process.component.html',
  styleUrls: ['./client-process.component.css']
})
export class ClientProcessComponent implements OnInit {

  @Output() public checklistsOut = new EventEmitter();
  resultChecklists = [];
  
  checklistsInventary = [
    {
      label: 'Visado de estudios',
      checklist: 'createVisadoChecklist'
    },
    {
      label: 'Requisitos NIE',
      checklist: 'createNieChecklist'
    },
    {
      label: 'Requisitos Renovación NIE',
      checklist: 'createRenovacionNieChecklist'
    },
    {
      label: 'Seguro Médico',
      checklist: 'createSeguroChecklist'
    },
    {
      label: 'Día a día',
      checklist: 'createDiaDiaChecklist'
    },
    {
      label: 'A la llegada a España',
      checklist: 'createLlegadaChecklist'
    },
    {
      label: 'Permiso de búsqueda de empleo',
      checklist: 'createEmpleoChecklist'
    },
    {
      label: 'Búsqueda de Universidad/centro estudios',
      checklist: 'createBusquedaU'
    }
  ];
  progress;
  visible = [];

  constructor(private resolver: ResolverService,private commonFunctions: FunctionsService) { }

  ngOnInit(): void {
  }

  isLoadingChecklists(){
    return this.resolver.isLoading('clientChecklists');
  }

  reloadChecklists(){
    this.resolver.getProcessedChecklists('clientChecklists',true,this.commonFunctions.getSelectedClientId()); /*  */
  }

  getCheckLists(){
    if(this.resolver.getDependencyRecords('clientChecklists')){
      this.processChecklists();
    }
    return this.resolver.getDependencyRecords('clientChecklists');
  }


  getFilteredChecklists(){
    if(this.resolver.getDependency('clientChecklists') && this.resolver.getDependency('clientChecklists').length>0){
      return this.resolver.getDependency('clientChecklists');
    }else{
      return [];
    }
  }

  processChecklists(){
    let ids = this.getChecklistIds();
    let buffer = [];

    for(const [i,id] of ids.entries()){
      let list = [];
      
      for(let che of this.getCheckLists()){
        if(che.checklist_id == id){
          list.push(che);
          
        }
      }
      buffer[i] = {
        id: id,
        name: list[0]? list[0].name : '',
        list: list
      }
    }    
    this.resultChecklists = buffer;
    this.checklistsOut.emit(buffer);
  }

  getChecklistIds(){
    let ids = [];
    for(let che of this.getCheckLists()){
      if(!this.commonFunctions.arrayHasElement(ids,che.checklist_id)){
        ids.push(che.checklist_id);
      }
    }
    return ids;
  }

  createChecklist(checklistChoice){

/*     this.apiConnector.simpleQueryId(checklistChoice,this.commonFunctions.getSelectedClientId(),null,null,null,null).
    subscribe(response => this.confirmChange(response)); */

  }

  // CHECKLIST
  clickOn(item){
    !this.visible[item.id]?  this.visible[item.id] = true : this.visible[item.id] = false;
  }

  isVisible(item){
    return this.visible[item.id];
  }

  complete(item){
/*     this.oldObject = Object.assign({}, item);
    item.completed == 1? item.completed = "0": item.completed = "1";

    this.apiConnector.executePutApiRequest('checkOption',item.checklist_id,item.id,this.getClientDetails().id,item.completed,item)
      .subscribe(response => this.saveClientChecklists(response)); */
  }

  getBarCss(){
    let css;
     this.progress < 100? css ='progress-bar' : css ='progress-bar finished';
     return css;
  }

}
